//import { interpolateSinebow } from 'd3-scale-chromatic';

/*

 * Ability to zoom into a specific time period of the plot. We would like to interact with the plot in the following ways:

 Display a mini plot that shows entire selected time range and allow user to drag bars on the mini plot to expand plot details in a zoomed-in plot above the mini plot. See link below to illustrate functionality.
 Allow user to type in a date range for the zoomed in plot.
 Allow user to type in x number of days before today to zoom in on plot.
 For modeled data, allow user to type in x number of days after today to zoom in on plot.


 Allow user to hover over the main plot to see only one data value and date/time information at a time for each line.

 * If multiple values are displayed in the same pixel for the same line, show the first one chronologically. Show one value from one pixel for each time series.
 If multiple time series are displayed on the same plot, the value displayed should be for the earliest date/time across all lines. If a line doesn't have that date/time, it should display "no value."


 The legend label should contain the following information:

 * The model run member name
 value (For actual nulls, display "null," and for no value, display "no value") Values should include thousand separators. Display the number of decimal points from the database unless it is greater than two, then round to the hundredths place.
 date and time, time zone labeled "UTC"
 units

 * The legend should have one value per line.
 * There should be a point on the line showing the location of the data value as well as a vertical dashed line through date axis and the entire plot.
 * Allow users to zoom in and out within the queried date range. Maximum zoom range would be as far as you can physically push two things together on the screen.
 * In the mini-plot for model runs, show all of the lines that display in the main plot.
 * Snap the vertical cursor to the closest point within a specified pixel range (TBD).

 Use link below as an example of functionality:
 https://waterdata.usgs.gov/monitoring-location/10348000/#parameterCode=00060&period=P7D&compare=true
 Note: Allison has contacts at USGS to possibly get code for some of this functionality.
 Question: Can the the plotting functionality remain on one page as it is now, or with these added interactive plot requirements, would each plot need to open on a separate page?

 */
const graphsConfig = {
  // Max height of all combined headings relative to graph height
  headerMaxHeight: 0.12,
  // Size relative to graph height
  textSize:        0.03,
  // Size relative to text height
  subtextRatio:    0.8,

  // @see ../dates.js to configure date formats
  // If domain >= tickYearFormatAt (e.g. 5 years), display tickYear format
  tickYearFormatAt:      [ 5, 'years' ],
  // If domain >= tickYearMonthFormatAt (e.g. 12 months), display tickYearMonth format
  tickYearMonthFormatAt: [ 12, 'months' ],
  // If domain >= tickDateFormatAt (e.g. 10 days), display tickDate format
  tickDateFormatAt:      [ 10, 'days' ],
  // Otherwise, display tickDateTime format

  dataKeyColors: {
    // Color function for source hues
    //fn: interpolateSinebow,
    // True if color function wraps around to original color; i.e. fn(0) === fn(1)
    // Note: although cyclic may be true for default color function, cyclic will
    // default to false if color function given with call to contrastingColors().
    //cyclic: true,
    // Minimum number of hues to use before shading and at all times
    //minHues: 6,
    // Manipulate to get more/less hues per shade
    //hueShadeRatio: 1.5,
    // Min/max amount of shade to add to hue; rgb * Math.pow(0.7, shade)
    // e.g. 128 * Math.pow(0.7, 0) === 128; e.g. 128 * Math.pow(0.7, 2) === 62.72
    //minShade: 0,
    //maxShade: 2,
  },
};

export default graphsConfig;
